// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.icon{width:25px;margin-left:10px;cursor:pointer}`, "",{"version":3,"sources":["webpack://./src/views/Login/components/changePassword/styles.css"],"names":[],"mappings":"AAAA,MACI,UAAA,CACA,gBAAA,CACA,cAAA","sourcesContent":[".icon{\r\n    width: 25px;\r\n    margin-left: 10px;\r\n    cursor: pointer;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
